import React from 'react';
import MainPage from './Pages/MainPage'; // Import the MainPage component

function App() {
  return (
    <div className="App">
      <MainPage />
    </div>
  );
}

export default App;
